// extracted by mini-css-extract-plugin
export default {"modal":"gift-options-modal_modal__0a8e3","isProcessing":"gift-options-modal_isProcessing__31532","giftOptionsList":"gift-options-modal_giftOptionsList__9b3fb"};